//Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	

import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Button, Grid, Typography, Box, } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectParticipantDemographicsById, updateParticipantDemographics } from '../../../reducers/admincenter_participantdemographics';
import { adminparticipantModify, selectAdminParticipantById } from '../../../reducers/admincenter_participants';

/**
 * 
 *                   "ParticipantArchive": {
                        "CloseButton": "Close",
                        "ConfirmButton": "Confirm",
                        "Message": "Archiving a participant will remove them from the default search results.",
                        "Message2": "Archiving participants will still show up in group reports unless they are excluded through advanced report options.",
                        "Title": "ARCHIVE PARTICIPANT"
                    },} props 
 * 
 */

const ParticipantDeactivate = (props) => {
    const dispatch = useDispatch()

    const ParticipantGuid = props.Participant.ParticipantGuid
    const Participant = useSelector(state => selectAdminParticipantById(state, ParticipantGuid))
    const { user: currentUser } = useSelector((state) => state.auth);
    const ParticipantArchive = props.ParticipantTab && props.ParticipantTab.ParticipantArchive
    const ParticipantAdditionalInfo = useSelector(state => selectParticipantDemographicsById(state, Participant.ParticipantGuid))
    const [localDemographicState, setLocalDemographicState] = useState({ ...Participant, ...ParticipantAdditionalInfo })
    //console.log('part', Participant)

    const sanitizeNull = (val) => {
        if (!val || val == -1) {
            return "~_~"
        } return val
    }

    const SaveToDatabase = () => {
        let errorInSaving = false

        // save demographics
        let DemoToSave = {
            ...localDemographicState
            , authToken: currentUser.AuthToken
            , ParticipantGroupGuid: sanitizeNull(localDemographicState.ParticipantGroupGuid)
            , LanguageID: sanitizeNull(localDemographicState.LanguageID)
            , Lastname: sanitizeNull(localDemographicState.Lastname)
            , Firstname: sanitizeNull(localDemographicState.Firstname)
            , Middlename: sanitizeNull(localDemographicState.Middlename)
            , BioDOB: sanitizeNull(localDemographicState.BioDOB)
            , BioGender: sanitizeNull(localDemographicState.BioGender)
            , BioRace: sanitizeNull(localDemographicState.BioRace)
            , BioRace2: sanitizeNull(localDemographicState.BioRace2)
            , BioRace3: sanitizeNull(localDemographicState.BioRace3)
            , SpokenLanguageID: sanitizeNull(localDemographicState.SpokenLanguageID)
            , Email: sanitizeNull(localDemographicState.Email)
            , Status: sanitizeNull(Participant.Status === true ? "0" : "1")
            , EducationLevelGuid: sanitizeNull(localDemographicState.EducationLevelGuid)
            , Medicaid: sanitizeNull(localDemographicState.Medicaid)
        }

        dispatch(updateParticipantDemographics(DemoToSave))

        let UserTableToSave = {
            ...localDemographicState,
            FirstName: localDemographicState.Firstname,
            LastName: localDemographicState.Lastname,
            UserName: localDemographicState.UserName,
            StatusDisplay: (DemoToSave.Status === "1" || DemoToSave.Status === 1 || DemoToSave.Status === true) ? "Active" : "InActive",
            Status: (DemoToSave.Status === "1" || DemoToSave.Status === 1 || DemoToSave.Status === true) ? true : false,
            BioDOB: localDemographicState.BioDOB
        }

        dispatch(adminparticipantModify(UserTableToSave))




        props.cancelButton()

    }

    const handleModifyLocal = (k, v) => {
        let copy = { ...localDemographicState, [k]: v }

        setLocalDemographicState(copy)

    }




    return (
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={4}>
            <Grid item xs={12}>
                <Typography variant="h4" align="center">{Participant.Status === true ? "Archive" : "Activate"} Participant</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1" align="center">Are you sure you want to {Participant.Status === true ? "archive" : "activate"} {localDemographicState.UserName}?</Typography>
            </Grid>

            <Grid item xs={12} justifyContent="center">
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="success"
                                onClick={() => { SaveToDatabase() }}>{Participant.Status === true ? "Archive" : "Activate"}</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="error" onClick={() => { props.cancelButton() }}>Cancel</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>


        </Grid>
    )

}
export default ParticipantDeactivate
